import { FilterList, Filter } from './types';

/**
 * Validate FilterList mode, and use the filter function on each individual filter
 *
 * To be used where a fully valid filter list with filters is expected as input.
 *
 * Returns nothing and throws if a something is incorrect
 */
export const validateFilterList = (filterList: FilterList, filterValidator: (filter: Filter) => void): void => {
  if (!filterList) {
    throw new Error('Missing filter list');
  }

  if (!['all', 'any'].includes(filterList.mode)) {
    throw new Error('Incorrect filter list mode');
  }

  if (!filterList.filters?.length) {
    throw new Error('Filters are missing');
  }

  filterList.filters?.forEach(filterValidator);
};
